import {denormFn, normFn} from '../normalizerSupport';
import * as Types from './types';

export const normalize = normFn<Types.CustomRunColorsObjSchema>(
  'run-colors',
  whole => whole
);

export const denormalize = denormFn<Types.CustomRunColorsObjSchema>(
  part => part
);
